import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WhiteLabelConfigService } from './white-label-config.service';
import { WHITE_LABEL_HEADER_NAME } from './white-label.consts';

@Injectable()
export class WhiteLabelInterceptor implements HttpInterceptor {
  private readonly whiteLabelConfigService: WhiteLabelConfigService;

  constructor() {
    this.whiteLabelConfigService = inject(WhiteLabelConfigService);
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const whiteLabelHash = this.whiteLabelConfigService.config.hash;
    if (whiteLabelHash) {
      req = req.clone({
        setHeaders: { [WHITE_LABEL_HEADER_NAME]: whiteLabelHash }
      });
    }

    return next.handle(req);
  }
}

export const whiteLabelInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: WhiteLabelInterceptor,
  multi: true,
};
